(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .directive('legendGroup', function () {
        return {
          restrict: 'E',
          controller : 'LegendGroupCtrl as vm',
          bindToController: true,
          templateUrl : 'StandardReports/HighCharts/LegendGroup/LegendGroup.tmpl.html',
          scope: {
            legendGroups: '='
          }
        };
      });

})();